import { createRouter, createWebHashHistory } from 'vue-router';

//errors
import ErrorPage from '../views/Error/Error.vue';

//Privacity
import PrivacityPage from '../views/Privacity/Privacity.vue';
//About
import AboutPage from '../views/About/About.vue';
//Terms
import TermsPage from '../views/Terms/Terms.vue';

const routes = [
  //Privacity
  {
    path: '/',
    redirect: '/privacity',
    // meta: { title: 'Politicas de Privacidad' },
    // name: 'Privacity',
    // component: PrivacityPage,
  },
  {
    path: '/privacity',
    meta: { title: 'Politicas de Privacidad' },
    name: 'Privacity',
    component: PrivacityPage,
  },
  //About
  {
    path: '/about',
    meta: { title: 'Acerca de esta App' },
    name: 'About',
    component: AboutPage,
  },
  //Terms
  {
    path: '/terms',
    meta: { title: 'Terminos y Condiciones' },
    name: 'Terms',
    component: TermsPage,
  },
  //errors
  {
    path: '/:pathMatch(.*)*',
    meta: { title: 'Pagina no encontrada - 404' },
    name: 'ErrorPage',
    component: ErrorPage,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;

    next();
  } else {
    next();
  }
});

export default router;
